import { FormFieldsApiType } from 'src/publisher/api/form-opt-in-api'
import { ContactSlugEnum } from 'src/shared/enums/contact-fields-enum'
import { FieldsValuesType } from '../context/form-context'

export const convertFormFieldValuesToFormFieldApi = (
  fieldsValues: FieldsValuesType,
): FormFieldsApiType =>
  Object.entries(fieldsValues).map(([slug, value]) => ({
    slug: slug as ContactSlugEnum,
    value,
  }))
